import { createIcon } from './icon-utils';

export const WorkflowIcon = createIcon({
  height: 24,
  path: 'M16.5 16.498h-6a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h3v-.75a.75.75 0 0 0-.75-.75h-4.5A2.25 2.25 0 0 1 6 6.748v-.75H1.5a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-6v.75c0 .414.336.75.75.75h4.5A2.25 2.25 0 0 1 15 9.748v.75h7.5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5H18v1.5h4.5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-12a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h6v-1.5zm-6 3v3h12v-3h-12zm0-7.5v3h12v-3h-12zm-9-10.5v3h12v-3h-12z',
  width: 24,
});
